var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headdom mr-24"},[_c('div',{class:_vm.activeItem == _vm.menuitem.id ? 'headitem itemactive' : 'headitem'},[_c('span',[_vm._v(_vm._s(_vm.menuitem.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }